import type { Post, TechNewsCategory } from '../types';

export const siteConfig = {
  title: 'Shangbanlun',
  description: '个人博客 - 分享技术学习笔记，记录生活点滴',
  author: 'shangbanlun',
};

export const posts: Post[] = [
  {
    id: 'hello-world',
    title: 'Hello World',
    date: '2026-03-07',
    summary: '欢迎来到我的个人博客！这是我的第一篇文章。',
    content: `欢迎来到我的个人博客！这是我的第一篇文章。

## 关于这个博客

这个博客使用 React + Vite 构建，部署在阿里云服务器上。

## 计划

- 分享技术学习笔记
- 记录生活点滴
- 练习写作

感谢来访！🎉`,
    tags: ['随笔', '开始'],
  },
];

// 自动更新于 2026/4/7 08:02:00
export const techNews: TechNewsCategory[] = [
  {
    name: '深度学习',
    key: 'deepLearning',
    items: [
      {
        title: '🔥 google-ai-edge/gallery',
        url: 'https://github.com/google-ai-edge/gallery',
        summary: 'Google设备端ML/GenAI展示库 - 本地运行AI模型，支持多种GenAI用例 - 17.8K+ stars，今日+1,107 stars',
        source: 'GitHub',
        date: '04-07',
        tag: '今日热门',
      },
      {
        title: '🔥 google-ai-edge/LiteRT-LM',
        url: 'https://github.com/google-ai-edge/LiteRT-LM',
        summary: 'LiteRT语言模型 - Google轻量级端侧LLM推理框架 - 1,997+ stars，今日+483 stars',
        source: 'GitHub',
        date: '04-07',
        tag: '今日热门',
      },
      {
        title: '🔥 Blaizzy/mlx-vlm',
        url: 'https://github.com/Blaizzy/mlx-vlm',
        summary: 'MLX-VLM视觉语言模型 - 在Mac上使用MLX进行VLM推理和微调 - 4,107+ stars，今日+277 stars',
        source: 'GitHub',
        date: '04-07',
        tag: '今日热门',
      },
      {
        title: '🔥 HKUDS/DeepTutor',
        url: 'https://github.com/HKUDS/DeepTutor',
        summary: 'DeepTutor智能学习助手 - Agent原生的个性化AI家教系统',
        source: 'GitHub',
        date: '04-07',
        tag: '热门项目',
      }
    ],
  },
  {
    name: '大模型',
    key: 'llm',
    items: [
      {
        title: '🔥 NousResearch/hermes-agent',
        url: 'https://github.com/NousResearch/hermes-agent',
        summary: 'Hermes Agent - 随你成长的AI智能体框架 - 28K+ stars，今日+1,574 stars',
        source: 'GitHub',
        date: '04-07',
        tag: '今日热门',
      },
      {
        title: '🔥 block/goose',
        url: 'https://github.com/block/goose',
        summary: 'Goose开源AI Agent - Block推出的可扩展AI代理，超越代码建议 - 支持安装、执行、编辑、测试',
        source: 'GitHub',
        date: '04-07',
        tag: '热门项目',
      },
      {
        title: '🔥 NVIDIA/personaplex',
        url: 'https://github.com/NVIDIA/personaplex',
        summary: 'PersonaPlex - NVIDIA推出的个性化AI角色框架 - 7,335+ stars，今日+295 stars',
        source: 'GitHub',
        date: '04-07',
        tag: '今日热门',
      },
      {
        title: '🔥 teng-lin/notebooklm-py',
        url: 'https://github.com/teng-lin/notebooklm-py',
        summary: 'NotebookLM Python API - Google NotebookLM的非官方Python API和Agent技能 - 9,354+ stars',
        source: 'GitHub',
        date: '04-07',
        tag: '热门项目',
      },
      {
        title: '🔥 badlogic/pi-mono',
        url: 'https://github.com/badlogic/pi-mono',
        summary: 'Pi-Mono AI工具包 - 编码Agent CLI、统一LLM API、TUI/Web UI库 - 32.4K+ stars，今日+519 stars',
        source: 'GitHub',
        date: '04-07',
        tag: '今日热门',
      }
    ],
  },
  {
    name: '自动驾驶',
    key: 'autonomousDriving',
    items: [
      {
        title: '🔥 commaai/openpilot',
        url: 'https://github.com/commaai/openpilot',
        summary: 'OpenPilot开源自动驾驶 - 支持250+车型，端到端驾驶系统 - 54K+ stars，持续热门',
        source: 'GitHub',
        date: '04-07',
        tag: '热门项目',
      },
      {
        title: '🔥 ultralytics/ultralytics',
        url: 'https://github.com/ultralytics/ultralytics',
        summary: 'YOLOv8/YOLO11 - 新一代目标检测框架，广泛应用于自动驾驶感知 - 36.2K+ stars',
        source: 'GitHub',
        date: '04-07',
        tag: '热门项目',
      },
      {
        title: '🔥 autonomousvision/tuw',
        url: 'https://github.com/autonomousvision/tuw',
        summary: '自动驾驶世界模型 - 基于Transformer的端到端驾驶预测 - 8.7K+ stars',
        source: 'GitHub',
        date: '04-07',
        tag: '热门项目',
      },
      {
        title: '🔥 WayveAI/Driving-with-LLMs',
        url: 'https://github.com/WayveAI/Driving-with-LLMs',
        summary: 'LLM增强自动驾驶 - Wayve开源的大模型驾驶系统 - 6.2K+ stars',
        source: 'GitHub',
        date: '04-07',
        tag: '热门项目',
      }
    ],
  },
];

export const navItems = [
  { label: '首页', path: '/' },
  { label: '文章', path: '/posts' },
  { label: '科技资讯', path: '/tech-news' },
  { label: '关于', path: '/about' },
];
